import './assets/Radio.css';const o = "_wrapper_3nb89_4", n = "_radioInput_3nb89_10", r = "_radioLabel_3nb89_19", a = "_noMarginBlock_3nb89_82", _ = {
  wrapper: o,
  radioInput: n,
  radioLabel: r,
  noMarginBlock: a
};
export {
  _ as r
};
